module.exports = __webpack_public_path__ + "static/media/search.88f531e1.svg";